<template>
  <div class="sornBG lightBG">
    <v-card elevation="3" width="600">
      <v-card-title class="justify-center mt-4">
        <h1 class="mb-2">Log In</h1>
      </v-card-title>
      <v-card-text class="pb-1">
        <v-container class="col-8">
          <v-row>
            <v-col>
              <v-alert
                id="error"
                :class="errorAnimation ? 'bounce' : ''"
                v-if="loginError"
                dense
                outlined
                type="error"
                >{{ loginError }}</v-alert
              >
              <v-form ref="form" v-model="valid" @submit.prevent="loginUser">
                <img
                  v-if="logoPath != null"
                  id="logo"
                  :src="logoPath"
                  alt="logo"
                />
                <v-text-field
                  id="username"
                  color="blue"
                  label="Username"
                  v-model="username"
                  prepend-icon="mdi-account-circle"
                  :rules="[rules.required]"
                ></v-text-field>
                <v-text-field
                  id="password"
                  color="blue"
                  label="Password"
                  v-model="password"
                  type="password"
                  prepend-icon="mdi-lock"
                  :rules="[rules.required]"
                ></v-text-field>
                <!-- <v-select
                  color='blue'
                  label='Workstation'
                  :items="workstationList"
                  item-text="workstation_description"
                  item-value="id"
                  v-model="workstation_id"
                  prepend-icon="mdi-laptop"
            ></v-select>-->
                <v-btn
                  id="loginButton"
                  class="my-4"
                  color="primary"
                  block
                  type="submit"
                  :disabled="!valid"
                  >Login</v-btn
                >
                <v-alert
                  v-if="noSubdomain"
                  text
                  color="primary"
                  icon="mdi-exclamation-thick"
                  >Subdomain Required</v-alert
                >
                <div id="versionNumber" class="pa-2 text-center">
                  Version {{ uiVersion }}
                </div>
                <div class="text-center pa-2">
                  Copyright &copy; Plott Labs {{ new Date().getFullYear() }}
                </div>
              </v-form>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'loginUser',
  data() {
    return {
      username: '',
      password: '',
      loading: false,
      workstationList: [],
      noSubdomain: false,
      valid: true,
      errorAnimation: true,
      rules: {
        required: (value) => !!value || 'Required.',
      },
    }
  },
  mounted() {
    console.log('something new on QA!')
    const host = window.location.host.split('.')
    console.log('host', host)
    let subdomain = ''
    let onPrem = false
    if (host.some((e) => e.includes('localhost'))) {
      subdomain = process.env.VUE_APP_SUBDOMAIN
    }
    if (host[host.length - 1] === 'local') {
      subdomain = ''
      onPrem = true
    }
    if (host.length < 3 && !onPrem) {
      if (!subdomain) {
        this.noSubdomain = true
      }
    } else {
      subdomain = host[0]
    }
    this.setSubdomain(subdomain)
    this.loadExistingLogo()
  },
  methods: {
    ...mapActions(['setSubdomain', 'setLogin', 'setLogon', 'loadExistingLogo']),
    logout() {
      this.$store.dispatch('logoffUser')
    },
    async loginUser() {
      //temporarily removes the animation class so it can be replayed if needed
      this.errorAnimation = false
      if (this.$refs.form.validate()) {
        this.loading = true
        try {
          await this.setLogon({
            username: this.username,
            password: this.password,
          }).then(() => {
            this.$store.commit('setLoginError', '')
            this.$router.push({ name: 'appSelection' })
          })
        } catch (e) {
          console.log(e)
          this.errorAnimation = true
          this.loading = false
        }
      }
    },
  },
  computed: {
    ...mapState(['loginError', 'logoPath']),
    uiVersion() {
      const version =
        process.env.VUE_APP_VERSION_MAJOR +
        '.' +
        process.env.VUE_APP_VERSION_MINOR +
        '.' +
        process.env.VUE_APP_VERSION_PATCH +
        '.' +
        process.env.VUE_APP_VERSION_BUILD
      return version
    },
  },
}
</script>

<style>
.sornBG {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
}
.center {
  align-items: center;
}

#logo {
  display: block;
  margin: 0 auto;
  max-width: 500px;
  max-height: 250px;
}

.bounce {
  animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
}

@keyframes shake {
  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }
  30%,
  50%,
  70% {
    transform: translate3d(-4px, 0, 0);
  }
  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }
}
</style>
